import { GET_EVENTI_AGENDA, GET_EVENTO_AGENDA, AGGIUNGI_EVENTO, MODIFICA_EVENTO, ELIMINA_EVENTO, GET_EVENTO_AGENDA_STATISTICHE, AGENDA_ERROR } from '../actions/types';

const initialState = {
    eventi: [],
    evento: null,
    loading: true
}
export default function(state = initialState, action){
    const { type, payload } = action;
    switch(type){
        case GET_EVENTI_AGENDA:
            return {
                ...state,
                eventi: payload,
                loading: false
            };
        case GET_EVENTO_AGENDA:
        case MODIFICA_EVENTO:
        case GET_EVENTO_AGENDA_STATISTICHE:
            return {
                ...state,
                evento: payload,
                loading: false
            };
        case AGGIUNGI_EVENTO:
            let arrayEventi = [...state.eventi];
            arrayEventi.push(payload);
            arrayEventi.sort((a, b) => {
                const dataDiff = new Date(b.data) - new Date(a.data);
                if (dataDiff !== 0) {
                    return dataDiff; 
                }
                const [oreA, minutiA] = a.orario.split(':').map(Number);
                const [oreB, minutiB] = b.orario.split(':').map(Number);
                return oreB - oreA || minutiB - minutiA;
            });
            
            return {
                ...state,
                eventi: arrayEventi,
                loading: false
            };
        case ELIMINA_EVENTO:
                return {
                  ...state,
                  eventi: state.eventi.filter(evento => evento._id !== payload),
                  loading: false
                };
        case AGENDA_ERROR:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}